export default {
  devicesTypesList: state => {
    return state.devicesTypes;
  },
  devicesStatusList: state => {
    return state.devicesStatus;
  }
};
